<template>
  <div class="gray head BGwhite relative">
    <div class="width1920 flex right relative C888 nowrap">
      <img :src="$store.state.siteInfo.Logo" :onerror="logoError" class="web-logo"
        @click.stop="$router.push({ path: '/' })" />
      <div class="label-box">
        <!-- <div class="label">筑才学院</div>
        <div class="xian" />
        <div class="tit">教育培训平台</div> -->

        <a @click="goto(item.url)" v-for="(item, index) in menuList" :key="index"
          class="relative f-s-0 block size15 ml50 homePath" :class="{ Con: item.activePath.includes($route.path) }">
          <span v-if="item.url != '/course'"> {{ item.title }}</span>
          <div v-else>
            <el-popover v-if="$route.path == '/'" placement="top-start" title="" trigger="hover">
              <el-cascader-panel :options="options" :props="propOptions" class="cascader-panel"
                @change="handleChange"></el-cascader-panel>
              <span slot="reference">{{ item.title }}</span>
            </el-popover>
            <span v-else>{{ item.title }}</span>
          </div>
        </a>
        <!-- <el-menu
          :default-active="activeIndex"
          text-color="#333333"
          mode="horizontal"
          router
          active-text-color="#1D79FF"
          class="relative f-s-0 block size15 ml50"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="study1">
            <template slot="title">课程中心</template>
<el-menu-item index="2-1">选项1</el-menu-item>
<el-menu-item index="2-2">选项2</el-menu-item>
<el-menu-item index="2-3">选项3</el-menu-item>
<el-submenu index="2-4">
  <template slot="title">选项4</template>
  <el-menu-item index="2-4-1">选项1</el-menu-item>
  <el-menu-item index="2-4-2">选项2</el-menu-item>
  <el-menu-item index="2-4-3">选项3</el-menu-item>
</el-submenu>
</el-submenu>
<el-menu-item index="/1">资料下载</el-menu-item>
<el-menu-item index="/2">题库中心</el-menu-item>
<el-menu-item index="/3">报名通知</el-menu-item>
<el-menu-item index="/4">师资专家</el-menu-item>
</el-menu> -->
      </div>

      <div class="myInput flex between mr20 ml10 nowrap">
        <img src="@/assets/img/home/1.png" class="mr10 pointer home1" alt="" />
        <input class="input" type="text" v-model="searchInput" placeholder="输入关键词搜索" />
        <el-button type="primary" class="h39" @click="toSearch">搜索</el-button>
      </div>
      <div class="flex between mr20 ml10 nowrap">
        <div v-if="!isLogin" class="login-btn" @click="showLogin = true">
          <img src="@/assets/img/home/5.png" class="mr5 home5" alt="" />注册/登录
        </div>
        <div v-if="isLogin" class="login-btn" @click="link">
          <img src="@/assets/img/home/5.png" class="mr10 home5" alt="" />个人中心
        </div>
        <!-- <el-dropdown v-if="isLogin" placement="bottom" class="f-s-0">
          <div class="avatar">
            <img :src="userInfo.Avatar" :onerror="userError" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="link()">个人中心</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <login :isShowActiveAccount="$store.state.LoginShow" @closePop="closePop"></login>
  </div>
</template>

<script>
import { Course_GetTypes, Course_GetClassifys } from "@/api/course";
import { GetUserInfo } from "@/api/member";
import { getToken, setToken, removeToken } from "@/util/auth";
import { Message } from "element-ui";
import login from "@/components/login.vue";
import Bus from "@/util/bus";
export default {
  name: "myhead",
  components: {
    login,
  },
  data() {
    return {
      options: [],
      typeList: [],
      classifyList: [],
      propOptions: {
        value: "ClassifyID",
        label: "ClassifyName",
        children: "children",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      userInfo: {
        Avatar: "",
      },
      showLogin: false,
      activeIndex: "/",
      searchType: 0,
      isLogin: getToken() ? true : false,
      dialogVisible: false,
      showSearch: false,
      radio: 1,
      getListData: {
        Title: null,
        FileType: null,
        StartDate: null,
        EndDate: null,
        type: null,
      },
      menuList: [
        {
          title: "首页",
          url: "/",
          activePath: ["/", "/search"],
        },
        {
          title: "课程中心",
          url: "/course",
          activePath: [
            "/course",
            "/courseDetail",
            "/chapterDetail",
            "/exam/detail",
            "/exam/result",
          ],
        },
        {
          title: "资料下载",
          url: "/material",
          activePath: ["/material", "/materialDetail"],
        },
        {
          title: "题库中心",
          url: "/qbank",
          activePath: [
            "/qbank",
            "/qbankDetail",
            "/qbankCreate",
            "/exam/exercises",
            "/exam/result2",
          ],
        },
        {
          title: "报名通知",
          url: "/apipcEnroll",
          activePath: ["/apipcEnroll", "/apipcEnrollDetail"],
        },
        {
          title: "师资专家",
          url: "/teacher",
          activePath: ["/teacher", "/teacherDetail"],
        },
      ],
      searchInput: "",
    };
  },
  props: {},
  mounted() {
    this.getCouse();
    if (this.isLogin) {
      this.getUserInfo();
    }
    Bus.$on("updateAvater", (target) => {
      this.getUserInfo();
    });
    Bus.$on("searchType2", (data) => {
      this.searchType = data;
    });
  },
  methods: {
    goto(path) {
      this.$router.push({
        path: path,
      });
    },
    handleChange(val) {
      if (val.length == 1) {
        this.$router.push({
          path: "/course",
          query: {
            PID: val[0],
          },
        });
      } else if (val.length == 2) {
        this.$router.push({
          path: "/course",
          query: {
            PID: val[0],
            ClassifyID: val[1] || null,
          },
        });
      } else if (val.length == 3) {
        this.$router.push({
          path: "/course",
          query: {
            PID: val[0],
            ClassifyID: val[1] || null,
            CourseType: val[2] | null,
          },
        });
      }
    },
    async getCouse() {
      await Promise.all([Course_GetTypes(), Course_GetClassifys()]).then(
        (values) => {
          this.typeList = values[0].data.map((item) => {
            return {
              ...item,
              ClassifyID: item.CourseType,
              ClassifyName: item.CourseTypeName,
            };
          });
          this.classifyList = values[1].data;
          this.options = this.resetList(this.classifyList);
        }
      );
    },
    resetList(data) {
      const that = this;
      let arr = data.map((item) => {
        if (item.Children && item.Children.length > 0) {
          item.children = item.Children;
          item.children.map((it) => {
            it.children = that.typeList;
          });
        }
        return {
          PID: item.PID,
          ClassifyID: item.ClassifyID,
          ClassifyName: item.ClassifyName,
          children: item.children,
        };
      });
      return arr;
    },
    getUserInfo() {
      GetUserInfo().then((res) => {
        // res.data.Avatar = this.webUrl + data.Avatar;
        this.$store.state.userInfo = {
          ...this.$store.state.userInfo,
          ...res.data,
        };
        this.userInfo = this.$store.state.userInfo;
      });
    },
    logOut() {
      this.$store.state.userInfo = {};
      location.replace(location.pathname);
      localStorage.removeItem("ShareAuthKey");
      removeToken("Token");
      this.isLogin = false;
    },
    closePop(flag) {
      console.log("closePop", "1212");
      this.isLogin = getToken() ? true : false;
      this.showLogin = false;
      this.$store.state.LoginShow = false;
    },
    toSearch() {
      let type = 1;
      if (this.$route.path == "/course") {
        this.type = 1;
      } else if (this.$route.path == "/material") {
        type = 2;
      } else if (this.$route.path == "/qbank") {
        type = 3;
      } else if (this.$route.path == "/apipcEnroll") {
        type = 4;
      } else if (this.$route.path == "/teacher") {
        type = 5;
      } else {
        type = this.$route.query.type || 1;
      }
      const data = {
        search: this.searchInput,
        type,
      };
      console.log(data);
      this.$router.replace({
        path: "/search",
        query: data,
      });
    },

    search() {
      const data = {
        search: this.getListData.Title,
        type: this.getListData.type || 0,
        FileType: this.getListData.FileType,
      };
      if (this.radio === 2) {
        data.StartDate = this.getListData.StartDate;
        data.EndDate = this.getListData.EndDate;
        if (data.EndDate < data.StartDate) {
          Message({ message: "时间选择有误！", type: "error" });
          return false;
        }
      }
      if (this.$route.name === "search") {
      } else {
        this.$router.push({
          path: "/search",
          query: data,
        });
      }
      this.reset();
      this.dialogVisible = false;
    },
    reset() {
      this.getListData = {
        Title: null,
        FileType: null,
        StartDate: null,
        EndDate: null,
        type: null,
      };
      this.radio = 1;
    },
    handleClose() {
      this.dialogVisible = false;
    },

    link() {
      if (getToken()) {
        if (this.$route.path != "/member/info") {
          this.$router.push({
            path: "/member/info",
          });
        }
      } else {
        this.showLogin = true;
        this.isLogin = false;
      }
    },
  },
  watch: {
    showLogin(val) {
      this.$store.state.LoginShow = val;
    },
    radio(newValue) {
      if (newValue === 1) {
        this.getListData.StartDate = null;
        this.getListData.EndDate = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
img[onerror] {
  background: #ffffff;
}

.web-logo {
  width: 180px;
  height: 50px;
  margin-left: 80px;
  margin-right: auto;
  cursor: pointer;
}

.avatar {
  cursor: pointer;
  margin-left: 10px;
  width: 50px;
  height: 50px;
  border-radius: 50%;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.home1 {
  width: 20px;
  height: 20px;
  margin-top: -2px;

  img {
    width: 100%;
    height: 100%;
  }
}

.home5 {
  width: 24px;
  height: 24px;

  img {
    width: 100%;
    height: 100%;
  }
}

.headDialog {
  .el-dialog__body {
    padding-top: 5px;
  }

  .el-radio {
    background: white;
    padding: 0 20px;
    min-height: 58px;
    display: flex;
    align-items: center;
    border-radius: 8px;
  }

  .el-input {
    margin-bottom: 16px;
    background: #f1f4f6;
    border-radius: 6px;
    min-height: 58px;
    line-height: 58px;
    font-size: 16px;
  }

  .el-input__inner {
    background: #f1f4f6;
    border: none;
  }

  .el-range-editor.el-input__inner {
    background-color: transparent;
  }
}

.myInput {
  width: 402px;
  height: 48px;
  background: #ffffff;
  border-radius: 8px;
  border: 2px solid #1d79ff;
  padding: 0 4px 0 14px;

  .BGf0 {
    height: 40px;
    padding: 0 10px;
    border-radius: 30px;
    flex-shrink: 0;
  }

  // input{ height: 100%; width:130px; background: white; }
  .input {
    flex-grow: 1;
    width: 0;
    margin: 0 10px;
    height: 19px;
    overflow: hidden;

    &.active {
      color: #333;
      position: relative;

      span {
        position: absolute;
        right: 1px;
        white-space: nowrap;

        &::after {
          content: "";
          width: 1px;
          height: 100%;
          display: inline-block;
          background-color: #000;
          animation: blink 1s infinite;
          position: absolute;
          top: 0;
        }
      }

      @keyframes blink {
        0% {
          opacity: 1;
        }

        50% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  }

  img {
    flex-shrink: 0;
  }
}

.head {
  a.block {
    line-height: 86px;
    padding: 0 5px;
    margin-right: 8px;
    white-space: nowrap;
    color: #333333;

    &.Con {
      color: #1d79ff;
    }

    &.Con:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 5px;
      height: 6px;
      background: #1d79ff;
      border-radius: 3px;
    }

    img.absolute {
      top: 36%;
    }
  }

  .homePath:hover {
    color: #1d79ff;

    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 5px;
      height: 6px;
      background: #1d79ff;
      border-radius: 3px;
    }

    img.absolute {
      top: 36%;
    }
  }

  .absolute.BGwhite {
    min-height: 100vh;
    background: linear-gradient(#f4f9fb,
        white 40px,
        white 540px,
        #bcc9df 541px,
        transparent);
  }

  .el-button--primary {
    width: 91px;
    background: linear-gradient(0deg, #3d5fff, #1c7aff) !important;
    border-radius: 6px;
    border: none !important;
    height: 39px;
    font-size: 16px;

    &:hover {
      filter: brightness(1.1);
    }
  }
}
</style>
<style lang="scss" scoped>
.login-btn {
  cursor: pointer;
  width: 130px;
  height: 46px;
  line-height: 44px;
  text-align: center;
  font-size: 16px;
  background: linear-gradient(90deg, #1c7aff, #2b50ff);
  border-radius: 8px;
  color: white;
  border: 1px solid #2f5aff;
}

::v-deep.el-menu--horizontal {
  border-bottom: none !important;

  .el-menu-item {
    margin: 0 20px !important;
    font-size: 16px !important;

    &.is-active {
      border-bottom: 4px solid #3d5fff !important;
    }
  }

  .el-submenu__title {
    font-size: 16px;
    color: #333333;
  }
}

.label-box {
  margin-right: auto;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;

  .xian {
    width: 1px;
    height: 16px;
    background: #cccccc;
    margin-left: 10px;
  }

  .label {
    font-size: 28px;
    font-weight: bold;
    color: #222222;
    margin-left: 20px;
  }

  .tit {
    margin-left: 10px;
    margin-right: 100px;
    font-size: 24px;
    color: #333333;
  }
}

.link1 {
  cursor: pointer;

  img {
    width: 80px;
    display: block;
  }
}

.date-picker {
  ::v-deep &.el-date-editor {
    width: 150px;
    margin-bottom: 0;
    background-color: #fff;

    .el-input__inner {
      background-color: #fff;
      padding: 0 16px;
    }

    &.end {
      width: 165px;

      .el-input__prefix {
        right: 0;
        left: auto;
      }
    }
  }
}

.my-style1 {
  ::v-deep &.el-select {
    width: 55px;

    .el-input--suffix {
      display: flex;

      .el-input__inner {
        padding: 0;
        border: none;
        background: transparent;
      }
    }

    .el-icon-arrow-up:before {
      content: "\e78f";
    }

    // .el-input__suffix{
    //   display: none;
    // }
  }
}

.mybtn1 {
  width: 120px;
  height: 48px;
  cursor: pointer;
  border: solid 1px #206bfb;
  box-shadow: inset 0 0 0 4px white;
  background: #e3edff;
  border-radius: 30px;

  &:hover {
    background: #d0e1ff;
  }
}

.myList {
  padding: 0 12px;

  li {
    height: 90px;
    background: #fff;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background: #fff5f6;
      color: #eb525c;

      img {
        filter: none;
      }
    }

    img {
      margin-top: 25px;
      margin-bottom: 5px;
    }
  }
}

.cascader-panel {
  // height: auto;
  max-height: 900px;

  ::v-deep .el-cascader-menu__wrap {
    margin-bottom: 0px !important;
    height: auto;
    overflow-x: hidden;
  }
}
</style>
